import { Fragment, PureComponent } from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Label } from '~/elements';
import { isNotEmpty } from '~/utils';

import { Textinput } from './Textinput';

import styles from './HeightData.scss';

export class HeightData extends PureComponent {
  static readValue = (value) => {
    try {
      return JSON.parse(value || null) || {};
    } catch (e) {
      return {};
    }
  };

  state = {
    isHeightInCm: false,
  };

  static getDerivedStateFromProps({ value }) {
    const { cm, feet, inches } = HeightData.readValue(value);
    if (cm) {
      return {
        isHeightInCm: true,
      };
    }
    if (feet || inches) {
      return {
        isHeightInCm: false,
      };
    }

    return null;
  }

  onChangeHandler = (nextValue) => {
    const { onChange, value } = this.props;

    onChange({ ...HeightData.readValue(value), ...nextValue });
  };

  onBlurHandler = () => {
    const { onBlur, value } = this.props;
    onBlur(HeightData.readValue(value));
  };

  toggleState = () => {
    const { isHeightInCm } = this.state;
    const { onChange, value } = this.props;

    if (isNotEmpty(HeightData.readValue(value))) {
      onChange({});
      // No need to untouch field in react-final-form, clearing value is enough
    }

    this.setState({
      isHeightInCm: !isHeightInCm,
    });
  };

  render() {
    const { isHeightInCm } = this.state;
    const { fields, fieldsCm, autoFocus, value, name, className } = this.props;
    const valueFields = HeightData.readValue(value);
    const [cmField] = fieldsCm;

    const cmClassName = isHeightInCm ? ` ${styles.cm}` : '';

    return (
      <div className={`${styles.height}${cmClassName}`}>
        {!isHeightInCm ? (
          fields.map((field) => (
            <div className={styles.height__formControl} key={field.id}>
              <Field
                name={`${name}.${field.name}`}
                render={({ input, meta }) => (
                  <Textinput
                    {...field}
                    fieldName={field.name}
                    autoFocus={autoFocus && field.id === 'feet'}
                    className={classnames(className)}
                    onChangeHandler={this.onChangeHandler}
                    definition={valueFields[field.name]}
                    onBlur={this.onBlurHandler}
                    input={input}
                    meta={meta}
                  />
                )}
              />
              <Label htmlFor={field.id}>{field.name}</Label>
            </div>
          ))
        ) : (
          <Fragment>
            <Field
              name={`${name}.${cmField.name}`}
              render={({ input, meta }) => (
                <Textinput
                  {...cmField}
                  fieldName={cmField.name}
                  autoFocus={autoFocus}
                  className={classnames(className)}
                  onChangeHandler={this.onChangeHandler}
                  definition={valueFields[cmField.name]}
                  onBlur={this.onBlurHandler}
                  input={input}
                  meta={meta}
                />
              )}
            />
            <Label htmlFor={cmField.id}>{cmField.name}</Label>
          </Fragment>
        )}
        <div className={styles.buttonHolder}>
          <button type="button" onClick={this.toggleState}>
            {!isHeightInCm ? 'Use cm' : 'Use feet and inches'}
          </button>
        </div>
      </div>
    );
  }
}

export const ConnectedHeightData = HeightData;

HeightData.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fieldsCm: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  autoFocus: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

HeightData.defaultProps = {
  className: '',
  autoFocus: false,
};
